import { createGatewayAPIManager } from "@envestnet/envjs-component-openenv";
import AuthenticationService from "services/AuthenticationService";
import getUrlVars from "utils/urlHelpers";
import { getOpenenvHost } from "./apiUrls";
import storage from "./persistance";

// Replace 'any' below with any API Hook object, i.e. typeof PortalService
const wrapper = () =>
  createGatewayAPIManager<typeof AuthenticationService>({
    baseURL: "",
    key: "",
    secret: "",
  });
let apiHandler: ReturnType<typeof wrapper>;

declare global {
  type APIHandler = typeof apiHandler;
}

export function configureHandler(sessionExpiredHook?: () => void) {
  const baseURL = getOpenenvHost(window.location.hostname);

  const params = getUrlVars();
  const channel = params["_channel"] || process.env.CHANNEL || "envestnet"; // eslint-disable-line
  apiHandler = createGatewayAPIManager({
    baseURL,
    clientID: window.config.CLIENT_ID,
    channel,
    sessionExpiredHook,
    apiHooks: AuthenticationService,
  });

  if (!apiHandler.sessionKey) {
    const sessionKey = storage.getItem("SESSION_KEY");
    if (sessionKey) apiHandler.sessionKey = sessionKey;
  }
  if (!apiHandler.refreshToken) {
    const refreshToken = storage.getItem("REFRESH_TOKEN");
    if (refreshToken) apiHandler.refreshToken = refreshToken;
  }
}

export default () => apiHandler;
